import React from 'react'
import { Button, Toast, Modal } from '@ow/comps'
import { useParams } from 'react-router-dom'
import { useTbViewStore } from '@vt/hooks'
import useProjectStore from '@vt/hooks/lib/project/use-project-store'
import { pick, get } from 'lodash-es'
import {
  downloadTemplateUrl,
  importData,
  importZcData,
} from '@vt/apis/lib-ex/v2/givrali'

const ids =
  process.env.REACT_APP_DEP === 'dev'
    ? {
        uploadId: 616,
        uploadNewsId: 593,
      }
    : {
        uploadId: 1339,
        uploadNewsId: 1335,
      }

const Footer = function (close, changeFile) {
  return (
    <Button type="primary" className="relative">
      <input
        className="w-full h-full absolute opacity-0"
        type="file"
        accept=".xlsx, .xls"
        name="file"
        onChange={(file) => {
          changeFile(file)
          close()
        }}
      />
      导入
    </Button>
  )
}

const Importer = function ({ children }) {
  const { appId } = useParams()
  const { tbId, tbSlug, fetchTbData, importerConfig } = useTbViewStore(
    (state) => pick(state, ['tbId', 'fetchTbData', 'tbSlug', 'importerConfig'])
  )
  const standardArea = get(importerConfig, 'IsChineseStandardArea', false) // 是否用中文导入点位指标
  const firstColumnPicture = get(importerConfig, 'firstColumnPicture', true) // 将图片都放入第一个图片所在的列

  const { getToken } = useProjectStore((s) => pick(s, ['getToken']))
  const token = getToken()
  const responseFn = (resp) => {
    if (resp) {
      Toast.success({
        title: '导入成功',
        description: '',
      })
      fetchTbData()
    } else {
      Toast.error({
        title: '导入失败',
        description: '',
      })
    }
  }
  const changeFile = (file) => {
    const { files } = file.target
    const formData = new FormData()
    // 通过append() 方法向对象中添加files键值对
    formData.append('file', files[0])
    if (tbSlug === 'policy_self_file_3790a864_6477_4db0_b80c_b6832f100aea') {
      importZcData(appId, tbId, ids.uploadId, formData).then((res) => {
        responseFn(res)
      })
    } else if (
      tbSlug === 'xinwenzixunwenjianbiao_f0d9324a_77db_4e3e_ac88_be1516cab8b3'
    ) {
      importZcData(appId, tbId, ids.uploadNewsId, formData).then((res) => {
        responseFn(res)
      })
    } else {
      importData(appId, tbId, standardArea, firstColumnPicture, formData)
        .then((res) => {
          responseFn(res)
        })
        .catch(() => {
          Toast.error({ title: '导入失败' })
        })
    }
  }
  return (
    <Modal
      nested
      size="sm"
      showCloseButton
      trigger={children}
      footer={({ close }) => {
        return Footer(close, changeFile)
      }}
    >
      <div
        className="w-full flex flex-col items-center"
        style={{ fontSize: '0.8125rem' }}
      >
        <div className="w-full flex items-center justify-end down">
          <Button
            type="primary"
            opacityType="transparent"
            onClick={() => {
              if (
                tbSlug ===
                'policy_self_file_3790a864_6477_4db0_b80c_b6832f100aea'
              ) {
                window.open(downloadTemplateUrl(appId, ids.uploadId, token))
              } else if (
                tbSlug ===
                'xinwenzixunwenjianbiao_f0d9324a_77db_4e3e_ac88_be1516cab8b3'
              ) {
                window.open(downloadTemplateUrl(appId, ids.uploadNewsId, token))
              } else {
                window.open(downloadTemplateUrl(appId, tbId, token))
              }
            }}
          >
            下载模板
          </Button>
        </div>
        <div className="w-full text-white-400 mt-4">
          <div>请先下载导入模板，规范信息再上传</div>
          <div style={{ color: 'red' }}>
            注：请确保上传文件为.xlsx格式（不支持.xls格式）
          </div>
          <div style={{ color: 'red' }}>*文件大小不能超过200M</div>
        </div>
      </div>
    </Modal>
  )
}

export default Importer
